export default __webpack_public_path__ + "1216666785030dd08b50fdf08050553b.jpg";